import {
  CheckboxFieldContainer,
  CheckboxFormControlLabelSized,
  ErrorText,
  FieldWrapper,
} from "styles/formStyleComponents";
import Checkbox from "@mui/material/Checkbox";
import InfoIconWithTooltip from "./InfoIconWithTooltip";

const CheckboxFieldComponent = ({
  name,
  label,
  value,
  required,
  disabled,
  error,
  info,
  field = {},
  onChange,
}) => {
  const labelFontSize = field.labelFontSize;

  return (
    <FieldWrapper compact>
      <CheckboxFieldContainer>
        <CheckboxFormControlLabelSized
          labelFontSize={labelFontSize}
          control={
            <Checkbox
              checked={value || false}
              onChange={(e) => onChange(name, e.target.checked)}
              disabled={disabled}
              required={required}
            />
          }
          label={label}
        />
        <InfoIconWithTooltip info={info} />
      </CheckboxFieldContainer>
      {error ? <ErrorText error>{error}</ErrorText> : null}
    </FieldWrapper>
  );
};

export default CheckboxFieldComponent;

